import React from "react";
import { ReviewItemProps } from "../../types/ReviewTypes";
import "./Review.css";
import TextBox from "../Common/TextBox";

const ReviewItem: React.FC<ReviewItemProps> = ({ review, onEditReview }) => {
    return (
        <TextBox
            picture={review.picture}
            username={review.dubu_user}
            content={review.content}
            createdAt={review.created_at}
            updatedAt={review.updated_at}
            linkTo={`/review/${review.id}`}
            rating={Number(review.rating)}
            isOwner={review.is_owner}
            onEdit={() => onEditReview(review)}
            defaultAvatar="/dubuFace.jpg"
        />
    );
};

export default ReviewItem; 